import React from 'react';
import ModalPopover from '../ZUILib/ModalPopover';
import CommonUtil from '../../utils/commonUtil';
import Accordion from '../../pages/eventManagement/page/GiftList/components/Accordion';
import RadioButton from '../ZUILib/RadioButton';
import * as giftListActions from '../../pages/eventManagement/page/GiftList/actions';
import * as defaultConst from '../../utils/clientConstant';
import TextInput from '../ZUILib/TextInput/TextInput';

import InputButton from '../ZUILib/InputButton';

import { unRatedStar, ratedStar } from '../NewHeader/Header/svgIcons';
import Image from '../ZUILib/Image';


const { updateGiftItemDetails,  handleRemoveItemsFromGiftlist } = giftListActions;
const channel = CommonUtil.getChannel();
const brand = CommonUtil.getBrand();
const colors = { LP: '#E10098', GAP: '#122344', PB: '#970400', PBK: '#74b0e2', WS: '#e81818', WLM: '#ed2724', TRU: '#007bff' };
export default class GiftModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      giftData: {
        addressId: "",
        availability: '',
        catalogRedirectionURL: '',
        categoryName: '',
        deliveryMode: defaultConst.constGiftDeliveryMode.Electrónicos,
        departmentId: '',
        desc: '',
        giftItemId: '',
        imageURL: '',
        isFavourite: false,
        listPrice: '',
        name: '',
        productId: '',
        productType: '',
        quantity: 1,
        salePrice: '',
        skuId: '',
        sortPrice: ''
      },
      deliverOwnerName: this.props.ownerName || '',
      addressList: this.props.deliveryAddressInfo || [],
      isChanged: false,
      initialGiftData: {},
      deleteModalActive: false,
    };
  }

  normalizeGiftData = (giftData) => {
    if (!giftData) return {};
    return {
      ...giftData,
      quantity: giftData.quantity ? parseInt(giftData.quantity, 10) || 1 : 1
    };
  };

  checkIfChanged = (newData) => {
    const { initialGiftData } = this.state;
    const fieldsToCompare = ['isFavourite', 'quantity', 'addressId', 'deliveryMode'];

    return fieldsToCompare.some(key => newData[key] !== initialGiftData[key]);
  };

  handleShow = (giftDetails, address) => {
    // const deliveryAddressName = giftDetails?.addressId ? address.find(addr => addr.deliveryAddressId === giftDetails.addressId)?.deliveryAddressName : '';
    const normalizedGiftData = this.normalizeGiftData(giftDetails);
    const hasAddressId = !!normalizedGiftData.addressId;
    const firstAddress = (address && address.length > 0) ? address[0] : null;
    this.setState({
      show: true,
      giftData: {
        ...normalizedGiftData,
        deliveryMode: giftDetails.deliveryMode || defaultConst.constGiftDeliveryMode.Electrónicos,
        addressId: hasAddressId ? normalizedGiftData.addressId : firstAddress?.deliveryAddressId || '',
      },
      initialGiftData: {
        ...normalizedGiftData,
        deliveryMode: giftDetails.deliveryMode || defaultConst.constGiftDeliveryMode.Electrónicos,
        addressId: hasAddressId ? normalizedGiftData.addressId : firstAddress?.deliveryAddressId || '',
      },
      deliverOwnerName: hasAddressId
        ? address.find(addr => addr.deliveryAddressId === normalizedGiftData.addressId)?.deliveryAddressName || ''
        : firstAddress?.deliveryAddressName || '',
      addressList: address || [],
      isChanged: false
    }, () => {
      this.modal.handleShow();
    });
  };

  handleSubmit = () => {
    const { giftData, addressList } = this.state;
    const url = window.location.href;
    const eventId = url.match(/\/(\d+)$/)[1];

    var defaultAddress = addressList && addressList.length >0 &&  addressList[0].deliveryAddressId || '';
    var addressId = giftData.addressId ?  giftData.addressId : defaultAddress;
    
    updateGiftItemDetails(
      eventId, 
      giftData.giftItemId, 
      `${giftData.quantity}`, 
      addressId, 
      giftData.deliveryMode, 
      `${giftData.isFavourite}`
    ).then((response) => {
      if(this.props.onUpdate){
        this.props.onUpdate(giftData)
      }
      this.handleHide();
    });
  };

  handleHide = () => {
    document.body.style.overflow = 'auto';
    this.modal.handleHide();
  };

selectQuantity = (e) => {
  const quantity = e.currentTarget.value && parseInt(e.currentTarget.value, 10) || 1;

  if (quantity >= 1 && quantity <= 999) {
    this.setState(prevState => {
      const updatedGiftData = {
        ...prevState.giftData,
        quantity
      };

      return {
        giftData: updatedGiftData,
        isChanged: this.checkIfChanged(updatedGiftData)
      };
    });
  }
};


  handleIncrement = () => {
    this.setState(prevState => {
      const currentQty = parseInt(prevState.giftData.quantity, 10) || 0;
      const newQty = Math.min(currentQty + 1, 999);

      const updatedData = {
        ...prevState.giftData,
        quantity: newQty
      };
      return {
        giftData: updatedData,
        isChanged: this.checkIfChanged(updatedData)
      };
    });
  };

  handleDecrement = () => {
    this.setState(prevState => {
      const currentQuantity = parseInt(prevState.giftData.quantity, 10) || 1;
      const newQuantity = Math.max(0, currentQuantity - 1);

      const updatedData = {
        ...prevState.giftData,
        quantity: newQuantity
      };
      return {
        giftData: updatedData,
        isChanged: this.checkIfChanged(updatedData)
      };
    });
  };

  handleFavorite = () => {
    this.setState(prevState => {
      const updatedData = {
        ...prevState.giftData,
        isFavourite: !prevState.giftData.isFavourite
      };
      return {
        giftData: updatedData,
        isChanged: this.checkIfChanged(updatedData)
      };
    });
  }

  handleAddressChange = (addressId, ownerName) => {
    this.setState(prevState => {
      const updatedData = {
        ...prevState.giftData,
        addressId: addressId
      };
      return {
        giftData: updatedData,
        deliverOwnerName: ownerName,
        isChanged: this.checkIfChanged(updatedData)
      };
    });
  };

  handleDeliveryModeChange = (mode) => {
  this.setState(prevState => {
    let newAddressId = "";
    let newOwnerName = "";
    
    if (mode === defaultConst.constGiftDeliveryMode.Físicos && prevState.addressList.length > 0) {
      newAddressId = prevState.addressList[0].deliveryAddressId;
      newOwnerName = prevState.addressList[0].deliveryAddressName;
    }
    const updatedData = {
        ...prevState.giftData,
        deliveryMode: mode,
        addressId: newAddressId
      }

    return {
      giftData: updatedData,
      deliverOwnerName: newOwnerName,
      isChanged: this.checkIfChanged(updatedData)
    };
  });
};

 handlePopUpCoOwner = (id) => {
    if (channel === 'web') {
      const data = document.querySelector('#' + id);
      if (data.style.display === 'block') {
        data.style.display = 'none';
      } else {
        data.style.display = 'block';
      }
    }
  }

  renderDeliveryModeButtons = () => {
    const { deliveryMode } = this.state.giftData;
    return (
      <div className="deliverModeSelect">
        <button 
          className={deliveryMode === defaultConst.constGiftDeliveryMode.Físicos ? 'selected' : ''}
          onClick={() => this.handleDeliveryModeChange(defaultConst.constGiftDeliveryMode.Físicos)}
        >
          {CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label')}
        </button>
        <button 
          className={deliveryMode === defaultConst.constGiftDeliveryMode.Electrónicos ? 'selected' : ''}
          onClick={() => this.handleDeliveryModeChange(defaultConst.constGiftDeliveryMode.Electrónicos)}
        >
          {CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label')}
        </button>
      </div>
    );
  };

  showModalForDeleteModal = () => {
    this.setState({ deleteModalActive: true }, () => {
      this.modalForDelete.handleShow();
    });
  }

  closeDeleteModal = () => {
    this.setState({ deleteModalActive: false }, () => {
      this.modalForDelete.handleHide();
      this.modal.handleShow();
    });
  }

  deleteGiftItemDetail = () => {
    this.confirmDeleteGiftFromList();
    this.modalForDelete.handleHide();
  }

  confirmDeleteGiftFromList = () => {
    const removeGiftItems = [];
    removeGiftItems.push(this.state.giftData.giftItemId);

    const url = window.location.href;
    const eventID = url.match(/\/(\d+)$/)[1];

    handleRemoveItemsFromGiftlist(eventID, removeGiftItems).then((response) => {
      this.isChanged = false;
      if (response.body.status.status === 'success') {
        // this.props.getRegisteredGiftList(this.props.eventId, '', '', '', '', true, this.state.categoryDepartmentId);
        this.props.onDelete();
        this.isChanged = false;
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        // this.showHidden(false);
      this.props.deletePopup.setMessage(CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.delete.article.element.gift.list'));
      }
    }).catch((e) => { console.log(e); });
  };
  handleAllowOnlyDigit = (e) => {
    const keyCode = String.fromCharCode(e.which || e.keyCode);
    if (!/^[0-9]$/.test(keyCode)) {
      e.preventDefault();
    }
  };
  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  };

  render() {
    const { show, giftData = {}, addressList, deliverOwnerName} = this.state;
    const numericQuantity = parseInt(giftData.quantity, 10) || 0;

    const deliveryModelable =  giftData?.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos ? CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label') : CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label');

    const accordionData = [
      {
        title: <><strong>{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.label')}</strong>: &nbsp;{deliveryModelable}</>,
        content: this.renderDeliveryModeButtons(),
        showOnLoad: true,
        isGiftCertificate: giftData.categoryName === 'Certificado Electrónico' ? true : false
      }
    ];

    const salePrice = giftData.salePrice ? CommonUtil.getCurrency(giftData.salePrice) : null;
    const [salePriceWhole, salePricecents] = salePrice?.split('.') ?? ['', ''];
    const salePriceFormatted = (
      <>
        {salePriceWhole}<sup>{salePricecents}</sup>
      </>
    );
    const listPrice = giftData.listPrice ? CommonUtil.getCurrency(giftData.listPrice) : null;
    const [listPriceWhole, listPricecents] = listPrice?.split('.') ?? ['', ''];
    const listPriceFormatted = (
      <>
        {listPriceWhole}<sup>{listPricecents}</sup>
      </>
    );
    const currencySymbol = listPriceWhole[0];
    const priceValue = listPriceWhole.slice(1).trim();
    const listPriceFormattedStrikeThrough = (
      <>
        <span className="textListPriceBefore">{currencySymbol}</span> <span className="textListPriceBefore">{priceValue}</span> <sup className="textListPriceBefore priceBefore fs-8">{listPricecents}</sup>
      </>
    );

    if (giftData.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos && this.props.deliveryAddressInfo.length > 0 && giftData.categoryName !== 'Certificado Electrónico') {
      accordionData.push({
        title: <><strong>{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.accordion.address.title')}</strong>: &nbsp;
        {giftData.addressId 
              ? this.props.deliveryAddressInfo.find(addr => addr.deliveryAddressId === giftData.addressId)?.deliveryAddressName 
              : (this.props.deliveryAddressInfo[0]?.deliveryAddressName || '')}</>,
        content: (
          <div className="radio-btn radio-del-address-container">
            {this.props.deliveryAddressInfo.map((ele, idx) => (
              <div className='radios-delivery-address' key={idx}>
                <input
                  // displayName={ele.deliveryAddressName}
                  name="deliveryAddress"
                  value={ele.deliveryAddressId}
                  type="radio"
                  id={ele.deliveryAddressId}
                  checked={giftData.addressId === ele.deliveryAddressId}
                  style={{
                    accentColor: `${colors[brand]}`,
                    marginRight: '10px',
                  }}
                  onChange={(e) => this.handleAddressChange(ele.deliveryAddressId, ele.deliveryAddressName)}
                  ref={ref => this.deliveryAddressID = ref}
                />
                <label className='radio-del-label' htmlFor={ele.deliveryAddressId}>
                  {ele.deliveryAddressName}
                </label>
              </div>
              // <RadioButton 
              //   key={idx} 
              //   displayName={ele.deliveryAddressName} 
              //   value={ele.deliveryAddressId} 
              //   id={ele.deliveryAddressId} 
              //   radioCssClass={'radio'} 
              //   name="deliveryAddress"
              //   checked={giftData.addressId === ele.deliveryAddressId ? true : ele.deliveryAddressId === this.props.deliveryAddressInfo[0].deliveryAddressId} 
              //   onChangeFunction ={(e) => this.handleAddressChange(ele.deliveryAddressId, ele.deliveryAddressName)}
              // />
            ))}
          </div>
        ),
        showOnLoad: true,
      });
    }

    const DeleteButtonforGift = {
      type: 'button',
      value: CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.elimination.buttton.label'),
      autoFocus: false,
      style: 'btn customBtnModalEnviar btnCancelarGift delButtonsHeight',
      onClickHandler: this.deleteGiftItemDetail,
    };
    const CancelDeleteButtonforGift = {
      type: 'button',
      value: CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosrecibidos.delete.status.for.cancel'),
      autoFocus: false,
      style: 'btn customBtnModalEnviar delButtonsHeight',
      onClickHandler: this.closeDeleteModal,
    };	
    const isCertificate = giftData.categoryName === CommonUtil.getLabel(this.props.lables.GuestviewPage, 'guestview.gift.certificate.name.label');
    if (giftData.categoryName === CommonUtil.getLabel(this.props.lables.GuestviewPage, 'guestview.gift.certificate.name.label')) {
      this.defaultImage = CommonUtil.getAssetURL() + '/images/certificado.jpg';
    } else {
      this.defaultImage = CommonUtil.getAssetURL() + "/images/guest/no-image.png";
    }

    const productImageAttribute = {
      id: 'productImg1',
      alt: 'Gift',
      src: giftData.imageURL,
      altImg: giftData?.altImageUrl || this.defaultImage,
      className: !isCertificate ? 'imageMaxHeight' : 'certificateImage',
    };

    return (
      <React.Fragment>
        {/* Modal for Delete */}
        < ModalPopover
          modalId="modalForDelete" dismiss="false" isModal="true"
          ref={modalForDelete => this.modalForDelete = modalForDelete}
          deleteModelClass="true"
          onClose={() => this.setState({ deleteModalActive: false })}
        >
          <div className="modalWrapper">
            <div className="row headOptionModal">
              <div className="col-xs-12"> <span className="titleOptionModal">{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.delete.elimination.article.buttton.label')}</span></div>              </div>
            <div className="row">
              <div className='col-xs-12'>
                {/* <div className="label">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')}</div> */}
                <div className="deleteGiftConfirmationMsg2">{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.delete.elimination.confirmation.modal')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <InputButton buttonAttr={DeleteButtonforGift} />
              </div>
              <div className="col-xs-6">
                <InputButton buttonAttr={CancelDeleteButtonforGift} />
              </div>
            </div>
          </div>
        </ModalPopover >

        <ModalPopover
          isModal="true"
          modalClass={`gift-guest gift-modal right-slide-modal ${show ? 'in' : ''} ${this.state.deleteModalActive ? 'background-blur' : ''}`}
          ref={(modal) => (this.modal = modal)}
          style={{ display: show ? 'block' : 'none' }}
        >
        <div className="modal-content modal-content-gift">
          <div className="modal-header clearfix gitf-details-bottom">
            <div><h4 className="modal-title">{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.modal.update.title')}</h4></div>
            <div className='closeButton'>
                <img
                  src={CommonUtil.getAssetURL() + "/images/close.svg"}
                  alt="web_giftlist_close_icon"
                  className="icon_vozcliente"
                  onClick={this.handleHide}
                />
            </div>
          </div>

          <div className="modal-body gift-modal-body modal-body-giftlist">
            <div className="gift-data-wrapper gitf-details-bottom">
              <div className={`gift-image ${!giftData.availability ? 'item-notAvailable' : ''}`}>
                  {giftData?.availability ?
                    <Image
                      imageAttr={productImageAttribute}
                      _imgsrc={giftData.imageURL || CommonUtil.getAssetURL() + "/images/guest/no-image.png"}
                      key={giftData.giftItemId}
                    />
                    : <React.Fragment>
                      <Image
                        imageAttr={productImageAttribute}
                        _imgsrc={giftData.imageURL || CommonUtil.getAssetURL() + "/images/guest/no-image.png"}
                        key={giftData.giftItemId}
                      />
                      <span>{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.item.notAvailable')}</span>
                    </React.Fragment>
                  }
              </div>
              <div className="gift-details">
                <div className='giftTitle'>{giftData.desc}</div>
                <div className='giftSku'>{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.modal.update.sku.lable')}: <span>{giftData.skuId}</span></div>
                <div className="giftPrice">
                  {salePrice < listPrice ?
                    <React.Fragment>
                        <span className="price"> <span>{listPriceFormattedStrikeThrough}</span> {salePriceFormatted}</span>
                    </React.Fragment>
                    :
                    <span className="price">{listPriceFormatted}</span>
                  }
                </div>
              </div>
            </div>

            <div className="quantity-details-wrapper gitf-details-bottom">
              <div className="quantity">{CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.modal.update.quantiy.lable')}</div>
              <div className="quantity-wrapper">
                <div className="">
                  <span
                    className="btn btn-default gift-quantity-btns"
                      onClick={numericQuantity <= 1 ? this.showModalForDeleteModal : this.handleDecrement}
                    // disabled={numericQuantity <= 0 || giftData.categoryName === 'Gift Certificate'}
                  >
                    {numericQuantity <= 1 ? ( <img src={CommonUtil.getAssetURL() + "/images/delete.svg"} alt="" className='modalIcons' />) : (<span className='glyphicon glyphicon-minus'/>) }
                  </span>
                </div>
                <div className=''>
                  {
                    giftData.categoryName !== 'Certificado Electrónico' ?
                     <TextInput className="text-center input-number gift-quantity number-input-no-arrows" value={numericQuantity} name='quantity' onKeyUp={this.selectQuantity} maxlength="3" onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }} onPaste={(e) => { this.onPasteFunc(e); }}/>
                     :
                    <TextInput className="text-center input-number gift-quantity" value={numericQuantity} name='quantity' readOnly disabled />
                  }
                </div>
                <div className="">
                  <span 
                    className="btn btn-default gift-quantity-btns"
                    onClick={this.handleIncrement}
                     disabled={giftData.categoryName === 'Certificado Electrónico' || numericQuantity >= 999}
                  >
                    <img src={CommonUtil.getAssetURL() + "/images/add.svg"} alt="" className='modalIcons' />
                  </span>
                </div>
              </div>
            </div>

            {/* {giftData.categoryName !== 'Gift Certificate' && ( */}
                <div className='mode_address_change'>
                  <Accordion items={accordionData} />
                </div>
            {/* )} */}
            
            <div className="gift-favorite-wrapper gitf-details-bottom tooltipBackdropBoda">
              <div className='formBlock tooltip-wrapper'> {CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.tooltip.favorite.title')}
                <div className='iconHelp inLine iconHelp-pl iconHelpWrapper giftlist-tooltip'><img src={CommonUtil.getAssetURL() + '/images/help.svg'} alt="icon_help" className="icon_help" onClick={() => { this.handlePopUpCoOwner('helpPopup'); }} />
                 <div className="tooltip-backdrop" />
                  <div id="helpPopup" className="popover bottom helpIconCssEmail">
                    <div className="arrow" />
                    <div className="popover-content">
                         {"Al marcarlo como favorito, este artículo se destacará al inicio de tu lista como “Más deseado” y será lo primero que vean tus invitados."}
                    </div>
                  </div>
                </div>
              </div>
            
              <div
                // className={`glyphicon ${giftData.isFavourite ? 'glyphicon-star' : 'glyphicon-star-empty'}`}
                style={{ marginLeft: '10px', color: '#f0c330' }}
                onClick={this.handleFavorite}
                className='favourite-icon'
              >
                 {giftData.isFavourite ? ratedStar : unRatedStar}
            </div>
            </div>
            <div className="modal-footer">
              <span className={`btn btn-block footerButton ${!this.state.isChanged ? 'disabled' : ''}`} onClick={this.state.isChanged ? this.handleSubmit : null}>
                {CommonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.modal.update.submit.btn')}
              </span>
            </div>
          </div>
        </div>
      </ModalPopover>
      </React.Fragment>
    );
  }
}